var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file)?_c('img',{attrs:{"src":_vm.src},on:{"error":_vm.changeUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }